import React, { useState, useEffect } from "react";
import "../Components/Products.css";
import "./BestsellingProducts.css";
import axios from "../api/axios";
import ProductCard from "../Components/ProductCard";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function BestsellingProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("/products/best-seller")
      .then(res => {
        if (res.data && res.data.data) {
          setProducts(res.data.data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching best sellers:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="category_outer_main bestselling_outer_main">
      <div className="container-fluid">
        <div className="row">

          <div className="col-lg-4 col-md-4 col-sm-12 col-12">
            <div className="leftalign_heading section_heading text-left">
              <h2>Best Selling Products</h2>
              <p>
                Indulge in the timeless elegance of thoughtfully crafted home
                textiles designed to elevate every corner of your living space.
              </p>
            </div>  
          </div>

          <div className="col-lg-8 col-md-8 col-sm-12 col-12">
            <div className="product_slider bestselling_product_slider">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-dark" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : products.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  No bestselling products found.
                </div>
              ) : (
                <Swiper
                  modules={[Navigation, Autoplay]}
                  slidesPerView={3}
                  loop={products.length >= 3}
                  autoplay={{ delay: 5000 }}
                  navigation
                  pagination={{ clickable: true }}
                  breakpoints={{
                    320: {
                      slidesPerView: 2,
                      spaceBetween: 5,
                    },
                    480: {
                      slidesPerView: 2,
                      spaceBetween: 5,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                    1024: {
                      slidesPerView: 3,
                      spaceBetween: 10,
                    },
                  }}
                >
                  {products.map((product) => (
                    <SwiperSlide key={product.id}>
                      <ProductCard product={product} />
                    </SwiperSlide>
                  ))}
                </Swiper>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
